import React, { useState } from 'react';

const MEMBERS = [
  { id: 'emma', name: 'Emma', age: 12, level: 'Intermediate', project: 'Dairy Goat', animal: 'Clover', progress: 68, color: 'var(--forest-mid)' },
  { id: 'liam', name: 'Liam', age: 9,  level: 'Junior',       project: 'Market Lamb', animal: 'Scout', progress: 42, color: 'var(--burg)' },
];

const DEADLINES = [
  { label: 'YQCA Certification', sub: 'Required before fair entry', days: 14, urgent: true },
  { label: 'Record Book Submission', sub: 'Lewis County Extension', days: 87, urgent: false },
  { label: 'Fair Entry Deadline', sub: 'Lewis County Fair Board', days: 61, urgent: false },
];

const ACTIONS = [
  { label: 'Log Today', sub: 'Quick daily entry', screen: 'log', bg: '#E8F5EE', iconColor: 'var(--forest-mid)', icon: PlusIcon },
  { label: 'Record Book', sub: 'Emma 68% done', screen: 'record', bg: '#F4E8F1', iconColor: 'var(--burg-light)', icon: BookIcon },
  { label: 'Deadlines', sub: '3 upcoming', screen: null, bg: '#FEF3E2', iconColor: 'var(--warning)', icon: CalIcon },
  { label: 'YQCA Status', sub: 'Renewal needed', screen: null, bg: '#FEE8E8', iconColor: 'var(--danger)', icon: ShieldIcon },
];

export default function Dashboard({ onNavigate }) {
  const [activeMember, setActiveMember] = useState('emma');
  const member = MEMBERS.find(m => m.id === activeMember);

  return (
    <div style={{overflowY:'auto', height:'100%', paddingBottom: 16}}>
      {/* Hero */}
      <div style={s.hero}>
        <div style={s.heroGreeting}>Good morning,<br/>Dawson family</div>
        <div style={s.heroSub}>Lewis County · 2025–2026 Project Year</div>
      </div>

      {/* Urgent deadline strip */}
      <div style={s.deadlineStrip}>
        <div style={s.deadlineIcon}>
          <CalIconSm />
        </div>
        <div style={{flex:1}}>
          <div style={s.deadlineTitle}>YQCA Certification Due</div>
          <div style={s.deadlineSub}>Required before Lewis County Fair entry</div>
        </div>
        <div style={{textAlign:'center'}}>
          <div style={s.daysNum}>14</div>
          <div style={s.daysLabel}>days</div>
        </div>
      </div>

      {/* Section label */}
      <SectionLabel>Members</SectionLabel>

      {/* Member cards */}
      <div style={s.memberRow}>
        {MEMBERS.map(m => (
          <div key={m.id} style={s.memberCard(m.id === activeMember)} onClick={() => setActiveMember(m.id)}>
            <div style={{...s.mAvatar, background: m.color}}>{m.name[0]}</div>
            <div style={s.mName}>{m.name}</div>
            <div style={s.mLevel}>{m.level} · {m.age}</div>
            <div style={s.mBarBg}>
              <div style={{...s.mBarFill, width: `${m.progress}%`}} />
            </div>
          </div>
        ))}
        <div style={{...s.memberCard(false), opacity:0.6}}>
          <div style={{...s.mAvatar, background:'var(--forest-light)', fontSize:18}}>+</div>
          <div style={{...s.mName, color:'var(--text-muted)'}}>Add</div>
          <div style={s.mLevel}> </div>
        </div>
      </div>

      {/* Active member project */}
      <SectionLabel>{member.name}'s Project</SectionLabel>
      <div style={s.projectCard}>
        <div style={s.projectCardTop}>
          <div>
            <div style={s.projectAnimal}>{member.animal}</div>
            <div style={s.projectMeta}>{member.project} · {member.level}</div>
          </div>
          <div style={s.progressRing}>
            <ProgressRing pct={member.progress} color={member.color} />
          </div>
        </div>
        <div style={s.statRow}>
          <StatBox val="47" label="Log entries" />
          <StatBox val="14wk" label="In project" />
          <StatBox val="$384" label="Spent" color="var(--burg)" />
        </div>
      </div>

      {/* Quick actions */}
      <SectionLabel>Quick Actions</SectionLabel>
      <div style={s.actionGrid}>
        {ACTIONS.map((a, i) => (
          <div key={i} style={s.actionTile} onClick={() => a.screen && onNavigate(a.screen)}>
            <div style={{...s.actionIcon, background: a.bg}}>
              <a.icon color={a.iconColor} />
            </div>
            <div style={s.actionLabel}>{a.label}</div>
            <div style={s.actionSub}>{a.sub}</div>
          </div>
        ))}
      </div>

      {/* Upcoming deadlines */}
      <SectionLabel>Upcoming Deadlines</SectionLabel>
      <div style={{padding: '0 16px', display:'flex', flexDirection:'column', gap:8}}>
        {DEADLINES.map((d, i) => (
          <div key={i} style={s.deadlineRow(d.urgent)}>
            <div style={{flex:1}}>
              <div style={s.dlLabel}>{d.label}</div>
              <div style={s.dlSub}>{d.sub}</div>
            </div>
            <div style={s.dlDays(d.urgent)}>
              <span style={{fontSize:18, fontWeight:600, fontFamily:'var(--ff-display)'}}>{d.days}</span>
              <span style={{fontSize:10, display:'block', letterSpacing:'0.05em'}}>days</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SectionLabel({ children }) {
  return <div style={{fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:'var(--text-muted)', padding:'14px 16px 8px'}}>{children}</div>;
}

function StatBox({ val, label, color }) {
  return (
    <div style={{flex:1, background:'#F6FAF8', border:'1px solid #DFF0E8', borderRadius:10, padding:'9px 8px', textAlign:'center'}}>
      <div style={{fontSize:18, fontWeight:600, color: color || 'var(--forest-mid)', fontFamily:'var(--ff-display)'}}>{val}</div>
      <div style={{fontSize:10, color:'var(--text-muted)', marginTop:2, letterSpacing:'0.04em'}}>{label}</div>
    </div>
  );
}

function ProgressRing({ pct, color }) {
  const r = 28, circ = 2 * Math.PI * r;
  const offset = circ - (pct / 100) * circ;
  return (
    <div style={{position:'relative', width:72, height:72}}>
      <svg width="72" height="72" style={{transform:'rotate(-90deg)'}}>
        <circle cx="36" cy="36" r={r} fill="none" stroke="#E8F0EC" strokeWidth="6"/>
        <circle cx="36" cy="36" r={r} fill="none" stroke={color} strokeWidth="6"
          strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"/>
      </svg>
      <div style={{position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--ff-display)', fontSize:17, color:'var(--text-head)'}}>
        {pct}%
      </div>
    </div>
  );
}

const s = {
  hero: {
    background: 'var(--forest-primary)',
    padding: '16px 16px 20px',
  },
  heroGreeting: {
    fontFamily: 'var(--ff-display)',
    fontSize: 24,
    color: '#fff',
    marginBottom: 4,
    lineHeight: 1.25,
  },
  heroSub: { fontSize: 12, color: 'var(--forest-pale)' },
  deadlineStrip: {
    margin: '0 16px',
    marginTop: -8,
    background: 'var(--burg)',
    borderRadius: 12,
    padding: '11px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  deadlineIcon: {
    width: 30, height: 30,
    background: 'rgba(255,255,255,0.15)',
    borderRadius: 7,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  },
  deadlineTitle: { fontSize: 12, fontWeight: 600, color: '#fff' },
  deadlineSub:  { fontSize: 11, color: 'rgba(255,255,255,0.75)' },
  daysNum:   { fontSize: 24, fontWeight: 700, color: '#fff', lineHeight: 1, fontFamily: 'var(--ff-display)' },
  daysLabel: { fontSize: 9, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.08em' },
  memberRow: { display: 'flex', gap: 10, padding: '0 16px', overflowX: 'auto', paddingBottom: 4 },
  memberCard: (active) => ({
    flexShrink: 0,
    width: 110,
    background: 'var(--surface)',
    border: active ? '1.5px solid var(--forest-mid)' : '1px solid var(--border)',
    borderRadius: 12,
    padding: '12px 10px',
    cursor: 'pointer',
    transition: 'border-color 0.15s',
  }),
  mAvatar: {
    width: 40, height: 40,
    borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'var(--ff-display)', fontSize: 17, color: '#fff',
    margin: '0 auto 8px',
  },
  mName:  { fontSize: 12, fontWeight: 600, color: 'var(--text-head)', textAlign: 'center' },
  mLevel: { fontSize: 10, color: 'var(--text-muted)', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 1 },
  mBarBg: { marginTop: 8, height: 4, background: '#E8F0EC', borderRadius: 2 },
  mBarFill: { height: '100%', borderRadius: 2, background: 'var(--forest-mid)' },
  projectCard: {
    margin: '0 16px',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: 14,
  },
  projectCardTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  projectAnimal: { fontFamily: 'var(--ff-display)', fontSize: 20, color: 'var(--text-head)' },
  projectMeta:   { fontSize: 12, color: 'var(--text-muted)', marginTop: 2 },
  statRow: { display: 'flex', gap: 8 },
  actionGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 8,
    padding: '0 16px',
  },
  actionTile: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '14px 12px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  actionIcon: { width: 34, height: 34, borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  actionLabel: { fontSize: 13, fontWeight: 600, color: 'var(--text-head)' },
  actionSub:   { fontSize: 11, color: 'var(--text-muted)' },
  deadlineRow: (urgent) => ({
    background: 'var(--surface)',
    border: `1px solid ${urgent ? '#F9D0C4' : 'var(--border)'}`,
    borderRadius: 10,
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  }),
  dlLabel: { fontSize: 13, fontWeight: 500, color: 'var(--text-head)' },
  dlSub:   { fontSize: 11, color: 'var(--text-muted)', marginTop: 1 },
  dlDays: (urgent) => ({
    textAlign: 'center',
    color: urgent ? 'var(--burg)' : 'var(--forest-mid)',
    minWidth: 42,
  }),
};

function PlusIcon({ color }) {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke={color} strokeWidth="2.5" strokeLinecap="round"/></svg>;
}
function BookIcon({ color }) {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2z" stroke={color} strokeWidth="2"/><path d="M9 7h6M9 11h6M9 15h4" stroke={color} strokeWidth="2" strokeLinecap="round"/></svg>;
}
function CalIcon({ color }) {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="17" rx="2" stroke={color} strokeWidth="2"/><path d="M3 9h18" stroke={color} strokeWidth="2"/><path d="M8 2v4M16 2v4" stroke={color} strokeWidth="2" strokeLinecap="round"/></svg>;
}
function ShieldIcon({ color }) {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2l8 3v5c0 5-3.5 9.3-8 11C7.5 19.3 4 15 4 10V5l8-3z" stroke={color} strokeWidth="2"/></svg>;
}
function CalIconSm() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="17" rx="2" stroke="#fff" strokeWidth="2"/><path d="M3 9h18" stroke="#fff" strokeWidth="2"/><path d="M8 2v4M16 2v4" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>;
}
